import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Row, Col, Button, Card, CardBody } from 'reactstrap';
import { Form, FormGroup, Field, Checkbox, CheckboxGroup, RadioGroup, Radio } from '@availity/form';
import { DateField } from '@availity/date';
import '@availity/yup';
import * as yup from 'yup';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import ProgressBar from '../../Common/components/ProgressBar';
import qualitystore from '../stores/QualityStore';

@observer
export default class IncidentDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reInitialize: false
    };
    if (qualitystore.getPageStatus('#incidentdetails') !== 'stepwizard-step active') {
      qualitystore.setPageStatus('#incidentdetails', 'active');
    }
  }

  componentWillUnmount = () => {
    this.setState({ reInitialize: false });
  }

  getDetailCategory = value => {
    qualitystore.setIncidentCategories(value);
  }

  setIncidentRepeat = value => {
    qualitystore.updateIncidentRepeat(value);
  }

  startofIncidentHandler = value => {
    this.setState({ reInitialize: !moment(value).isValid() });
    qualitystore.setIncidentStart(value);
  }

  endofIncidentHandler = value => {
    qualitystore.setIncidentEnd(value);
  }

  setPhysicalOrBehavior = value => {
    qualitystore.setPhysOrBehavior(value);
  }

  setMemberHospitalization = value => {
    qualitystore.setMemHospitalized(value);
  }

  originalAdmissionHandler = value => {
    this.setState({ reInitialize: !moment(value).isValid() });
    qualitystore.setOriginalAdmission(value);
  }

  dischargeDateHandler = value => {
    qualitystore.setDischargeDate(value);
  }

  setMemberReadmitted = value => {
    qualitystore.setmemReadmitted(value);
  }

  setAdditionalDetails = event => {
    const { value } = event.target;
    qualitystore.updateAdditionalDetails(value);
  }

  setReadmissionDateHandler = value => {
    this.setState({ reInitialize: !moment(value).isValid() });
    qualitystore.setReadmissionDate(value);
  }

  setReadmissionDischargeDateHandler = value => {
    qualitystore.setReadmissionDischargeDate(value);
  }

  submit = () => {
    const { history } = this.props;
    history.push('/reviewsubmit');
  }

  render() {

    const { reInitialize } = this.state;

    const {
      stateCode,
      incidentCategories,
      incident,
      physOrBehavior,
      memHospitalized,
      originalAdmission,
      dischargeDate,
      memReadmitted,
      readmissionDate,
      readmissDischargeDate
    } = qualitystore;

    const incidentRepeat = incident.incidentRepeat;

    return (
      <Card>
        <CardBody className="p-40">
          <ProgressBar />
          <NavLink exact to="/practitionerlocation" className={'btn btn-link backBtn'}>
            <i className="icon icon-angle-left" />
            Back
          </NavLink>
          <div className="border-form">
            <Form
              onSubmit={this.submit}
              enableReinitialize={reInitialize}
              initialValues={{
                incidentCategory: incidentCategories,
                physOrBehavRadio: physOrBehavior,
                incidentRepeatRadio: incidentRepeat,
                incident_start: incident.incidentStart,
                incident_end: incident.incidentEnd,
                memhospitalizedRadio: memHospitalized,
                originalAdmission: originalAdmission,
                dischargeDate: dischargeDate,
                memReadmittedRadio: memReadmitted,
                readmissionDate: readmissionDate,
                readmissDischargeDate: readmissDischargeDate,
                additionalDetails: incident.additionalDetails
              }}
              validationSchema={yup.object().shape({
                incidentCategory:
                  incidentCategories.length === 0 &&
                  yup
                    .array()
                    .required('Please select at least one of the above options!')
                    .typeError('Please select at least one of the above options!'),
                physOrBehavRadio:
                  yup
                    .string()
                    .required('Please select the incident type'),
                incidentRepeatRadio:
                  yup
                    .string()
                    .required('Please indicate whether incident occured more than once!'),
                incident_start:
                  yup
                    .date()
                    .nullable()
                    .max(moment().format('MM/DD/YYYY'), 'Date cannot be in the future')
                    .required('Please enter incident start date')
                    .typeError('Invalid Date'),
                incident_end:
                  incident.incidentRepeat === 'Yes' &&
                  yup
                    .date()
                    .nullable()
                    .when("incident_start", (incident_start, schema) => {
                      if (incident_start && moment(incident_start).isValid()) {
                        return schema.min(incident_start,
                          `Date must be between ${moment(incident.incidentStart).format('MM/DD/YYYY')} 
                          and ${moment().format('MM/DD/YYYY')}`)
                          .max(moment().format('MM/DD/YYYY'),
                            `Date must be between ${moment(incident.incidentStart).format('MM/DD/YYYY')} 
                          and ${moment().format('MM/DD/YYYY')}`)
                          .required('Please enter incident end date')
                          .typeError('Invalid Date')
                      }
                      return schema
                    }),
                memhospitalizedRadio:
                  yup
                    .string(),
                originalAdmission:
                  memHospitalized === 'Yes' &&
                  yup
                    .date()
                    .nullable()
                    .max(moment().format('MM/DD/YYYY'), 'Date cannot be in the future')
                    .required('Please enter member hospitalization date')
                    .typeError('Invalid Date'),
                dischargeDate:
                  memHospitalized === 'Yes' &&
                  yup
                    .date()
                    .nullable()
                    .when("originalAdmission", (originalAdmission, schema) => {
                      if (originalAdmission && moment(originalAdmission).isValid()) {
                        return schema.min(originalAdmission,
                          `Discharge date must be between ${moment(originalAdmission).format('MM/DD/YYYY')} 
                          and ${moment(originalAdmission).add(1, 'years').format('MM/DD/YYYY')}`)
                          .max(moment(originalAdmission).add(1, 'years').format('MM/DD/YYYY'),
                            `Discharge date must be between ${moment(originalAdmission).format('MM/DD/YYYY')} 
                          and ${moment(originalAdmission).add(1, 'years').format('MM/DD/YYYY')}`)
                          .required('Please enter Discharge Date')
                          .typeError(`Discharge date must be between ${moment(originalAdmission).format('MM/DD/YYYY')} 
                          and ${moment(originalAdmission).add(1, 'years').format('MM/DD/YYYY')}`)
                      }
                      return schema
                    }),
                memReadmittedRadio:
                  yup
                    .string(),
                readmissionDate:
                  memReadmitted === 'Yes' &&
                  yup
                    .date()
                    .min(moment().subtract(30, 'days').format('MM/DD/YYYY'),
                      "Please enter a date within the last 30 days")
                    .max(moment().format('MM/DD/YYYY'), 'Date cannot be in the future')
                    .required('Please enter member readmission date')
                    .typeError('Invalid Date'),
                readmissDischargeDate:
                  memReadmitted === 'Yes' &&
                  yup
                    .date()
                    .nullable()
                    .when("readmissionDate", (readmissionDate, schema) => {
                      if (readmissionDate && moment(readmissionDate).isValid()) {
                        return schema.min(readmissionDate,
                          `Discharge date must be between ${moment(readmissionDate).format('MM/DD/YYYY')} 
                            and ${moment(readmissionDate).add(1, 'years').format('MM/DD/YYYY')}`)
                          .max(moment(readmissionDate).add(1, 'years').format('MM/DD/YYYY'),
                            `Discharge date must be between ${moment(readmissionDate).format('MM/DD/YYYY')} 
                            and ${moment(readmissionDate).add(1, 'years').format('MM/DD/YYYY')}`)
                          .required('Please enter Discharge Date')
                          .typeError(`Discharge date must be between ${moment(readmissionDate).format('MM/DD/YYYY')} 
                          and ${moment(readmissionDate).add(1, 'years').format('MM/DD/YYYY')}`)
                      }
                      return schema
                    }),
                additionalDetails:
                  yup
                    .string()
                    .required('Incident description is Required')
              },
              )}
            >

              <h2 className="primarycardTitle">
                <b>Incident Details</b>
              </h2>
              <div className="titleSpacer" />
              <p>{`Asterisks (*) mark required fields`}</p>
              <div className='spacer' />
              <h6>
                <b>Please choose the category that best fits the incident:*</b>
                {` (check all that apply)`}
              </h6>
              <CheckboxGroup name="incidentCategory"
                className="custom-width-checkbox"
                onChange={this.getDetailCategory}
              >
                <Row>
                  <Col sm="3">
                    <Checkbox
                      groupName="incidentCategory"
                      label="Procedural Issues"
                      name="procIssues"
                      value="Procedural Issues"
                      checked={incidentCategories.includes('Procedural Issues')}
                    />
                    <Checkbox
                      groupName="incidentCategory"
                      label="Delay/Omission of Care"
                      name="delayOmission"
                      value="Delay/Omission of Care"
                      checked={incidentCategories.includes('Delay/Omission of Care')}
                    />
                    <Checkbox
                      groupName="incidentCategory"
                      label="Post-Op Complications"
                      name="postopComp"
                      value="Post-Op Complications"
                      checked={incidentCategories.includes('Post-Op Complications')}
                    />
                    <Checkbox
                      groupName="incidentCategory"
                      label="Medication Issues"
                      name="medIssues"
                      value="Medication Issues"
                      checked={incidentCategories.includes('Medication Issues')}
                    />
                  </Col>
                  <Col sm="3">
                    <Checkbox
                      groupName="incidentCategory"
                      label="Death or Serious Disability"
                      name="deathseriousDisablity"
                      value="Death or Serious Disability"
                      checked={incidentCategories.includes('Death or Serious Disability')}
                    />
                    <Checkbox
                      groupName="incidentCategory"
                      label="Patient Safety"
                      name="patientSafety"
                      value="Patient Safety"
                      checked={incidentCategories.includes('Patient Safety')}
                    />
                    <Checkbox
                      groupName="incidentCategory"
                      label="Quality of Service"
                      name="qualityService"
                      value="Quality of Service"
                      checked={incidentCategories.includes('Quality of Service')}
                    />
                    {stateCode === 'NC' ?
                      <Checkbox
                        groupName="incidentCategory"
                        label="Financial Harm"
                        name="financialHarm"
                        value="Financial Harm"
                        checked={incidentCategories.includes('Financial Harm')}
                      />
                      :
                      null
                    }
                  </Col>
                </Row>
              </CheckboxGroup>

              <div className='spacer' />

              <h6><b>Was this incident related to Physical Health or Behavioral Health?*</b></h6>
              <FormGroup for="physOrBehavRadio">
                <RadioGroup inline value={physOrBehavior} name="physOrBehavRadio" onChange={this.setPhysicalOrBehavior}>
                  <Radio className="custom-radio" label="Physical Health" value="Physical Health" />
                  <Radio className="custom-radio" label="Behavioral Health" value="Behavioral Health" />
                </RadioGroup>
              </FormGroup>

              <h6><b>Did the incident of harm occur more than once?*</b></h6>
              <FormGroup for="incidentRepeatRadio">
                <RadioGroup inline value={incidentRepeat} name="incidentRepeatRadio" onChange={this.setIncidentRepeat} >
                  <Radio className="custom-radio" label="Yes" value="Yes" />
                  <Radio className="custom-radio" label="No" value="No" />
                </RadioGroup>
              </FormGroup>

              <div className='spacer' />

              {incident.incidentRepeat === '' ?
                null
                :
                <>
                  {incident.incidentRepeat === 'Yes' ?
                    <h6><b>Incident(s) of harm occurred:*</b></h6>
                    :
                    null
                  }
                  <div className="mt-5" />
                  <Row>
                    <Col xs="12" sm="3" md="3">
                      {/* Incident Start Date cannot be future Date */}
                      <FormGroup for="incident_start">
                        <DateField
                          label={incident.incidentRepeat === 'Yes' ? "From" : 'Date of incident*'}
                          name="incident_start"
                          value={incident.incidentStart}
                          onChange={this.startofIncidentHandler}
                          placeholder='MM/DD/YYYY'
                          max={moment().format('MM/DD/YYYY')}
                        />
                      </FormGroup>
                    </Col>
                    {
                      incident.incidentRepeat === "Yes" ?
                        <Col xs="12" sm="3" md="3">
                          {/* Incident End Date must be between Incident Start Date and Today's date */}
                          <FormGroup for="incident_end">
                            <DateField
                              label="To"
                              value={incident.incidentEnd}
                              name="incident_end"
                              onChange={this.endofIncidentHandler}
                              placeholder='MM/DD/YYYY'
                              disabled={!incident.incidentStart}
                              min={incident.incidentStart ? moment(incident.incidentStart).format('MM/DD/YYYY') : moment().format('MM/DD/YYYY')}
                              max={moment().format('MM/DD/YYYY')}
                            />
                          </FormGroup>
                        </Col>
                        :
                        null
                    }
                  </Row>

                  <hr />

                  <h6><b>Has the member been hospitalized?</b></h6>
                  <FormGroup for="memhospitalizedRadio">
                    <RadioGroup inline value={memHospitalized} name="memhospitalizedRadio" onChange={this.setMemberHospitalization} >
                      <Radio className="repeat-radio" label="Yes" value="Yes" />
                      <Radio className="repeat-radio" label="No" value="No" />
                    </RadioGroup>
                  </FormGroup>

                  <div className='spacer' />
                  {
                    memHospitalized === 'Yes' ?
                      <>
                        <h4><b>Admission Information</b></h4>
                        <div className="mt-5" />
                        <Row>
                          {/* Original Admission Date cannot be in the future */}
                          <Col xs="12" sm="3" md="3">
                            <FormGroup for="originalAdmission">
                              <DateField
                                label='Original Admission Date'
                                name="originalAdmission"
                                value={originalAdmission}
                                onChange={this.originalAdmissionHandler}
                                placeholder='MM/DD/YYYY'
                                max={moment().format('MM/DD/YYYY')}
                              />
                            </FormGroup>
                          </Col>
                          {/* Discharge Date must be between "Original Admission Date" - "One year from Original Admission Date" */}
                          <Col xs="12" sm="3" md="3">
                            <FormGroup for="dischargeDate">
                              <DateField
                                label="Discharge Date"
                                name="dischargeDate"
                                value={dischargeDate}
                                onChange={this.dischargeDateHandler}
                                placeholder='MM/DD/YYYY'
                                min={moment(originalAdmission).format('MM/DD/YYYY')}
                                max={moment(originalAdmission).add(1, 'years').format('MM/DD/YYYY')}
                                disabled={!originalAdmission}
                              />
                            </FormGroup>
                          </Col>
                        </Row>

                        <div className='spacer' />

                        <h6><b>Has the member been readmitted within the last 30 days?</b></h6>
                        <FormGroup for="memReadmittedRadio">
                          <RadioGroup inline value={memReadmitted} name="memReadmittedRadio" onChange={this.setMemberReadmitted} >
                            <Radio className="repeat-radio" label="Yes" value="Yes" />
                            <Radio className="repeat-radio" label="No" value="No" />
                          </RadioGroup>
                        </FormGroup>

                        <div className='spacer' />
                        {
                          memReadmitted === 'Yes' ?
                            <>
                              <p>
                                <b>
                                  Date Member of readmission:
                                </b>
                              </p>
                              <Row>
                                <Col sm="3">
                                  <FormGroup for="readmissionDate">
                                    <DateField
                                      label="Admission Date"
                                      name="readmissionDate"
                                      value={readmissionDate}
                                      onChange={this.setReadmissionDateHandler}
                                      placeholder='MM/DD/YYYY'
                                      min={moment(new Date()).subtract(30, 'days').format('MM/DD/YYYY')}
                                      max={moment().format('MM/DD/YYYY')}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <div className='spacer' />
                              <p>
                                <b>
                                  Date Member was discharged:
                                </b>
                                &nbsp;(if applicable)
                              </p>
                              <Row>
                                <Col sm="3">
                                  <FormGroup for="readmissDischargeDate">
                                    <DateField
                                      label="Discharge Date"
                                      name="readmissDischargeDate"
                                      value={readmissDischargeDate}
                                      onChange={this.setReadmissionDischargeDateHandler}
                                      placeholder='MM/DD/YYYY'
                                      disabled={!readmissionDate}
                                      min={moment(readmissionDate).format('MM/DD/YYYY')}
                                      max={moment(readmissionDate).add(1, 'years').format('MM/DD/YYYY')}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                            </>
                            :
                            null
                        }
                      </>
                      :
                      null
                  }
                  <hr />

                  <div className='spacer' />

                  <FormGroup for="additionalDetails">
                    <Field
                      type="textarea"
                      id="additionalDetails"
                      label={
                        <h6>
                          <b>
                            Please provide these details about the incidents of harm (Incident Description, Root Cause,
                             Actions Taken, Case Mgr. Info. and Individuals/Agencies Notified if applicable):*
                          </b>
                        </h6>
                      }
                      name="additionalDetails"
                      className={'textAreaHeightDetails form-control form-group'}
                      onChange={this.setAdditionalDetails}
                      value={incident.additionalDetails}
                      row="3"
                      cols="200"
                      maxLength={65000}
                    />
                  </FormGroup>
                </>
              }
              <Button type="submit" color={"primary"} className={"btn btn-primary nextBtn"}>
                Next
              </Button>
            </Form>
          </div>
        </CardBody>
      </Card>
    );
  }
}

IncidentDetails.propTypes = {
  history: PropTypes.object
};